import { createGenericTypes, createGenericActions } from 'utils'

export const getExperiencesScheduledTypes = createGenericTypes(
  'GET_EXPERIENCE_SCHEDULED'
)
export const getExperiencesScheduledActions = createGenericActions(
  getExperiencesScheduledTypes
)
